<common-loading />
<router-outlet />
<common-toast />
